document.addEventListener("DOMContentLoaded", ()=>{
  geoLocateUser();
});

const setUserLocation = ({lat, lon, method, data}) => {
  window.userLocation = {
    method: method,
    latitude: lat,
    longitude: lon,
    data: data,
  };
  window.dispatchEvent(new CustomEvent("rove:userLocationSet", {detail: window.userLocation}));
  return window.userLocation;
}

const onGeoSuccess = async (position) => {
  const data = await reverseGeocode(
    position.coords.latitude,
    position.coords.longitude
  );
  return setUserLocation({
    lat: position.coords.latitude,
    lon: position.coords.longitude,
    method: "Geolocation API",
    data: data.address,
  });
};

const locateWithAlternativeProvider = async () => {
  console.log("Unable to retrieve your location via Geolocation API");
  console.log("AAAA Alternative provider");
  // priority of alternative providers
  // 1. WhoIs
  try{
    return await useWhoIsLocation();
  }catch(e){}
  
  // 2. Rebuy
  try{
    return await useRebuyLocation();
  }catch(e){}
  
}

const useRebuyLocation = async () => {
  console.log("Unable to retrieve your location via Geolocation API");
  if (!window.Rebuy) return;

  await new Promise((resolve) => setTimeout(resolve, 1000));

  const fallBackCordinates = await Rebuy.getGeolocation();
  const data = await reverseGeocode(
    fallBackCordinates.latitude,
    fallBackCordinates.longitude
  );
  return setUserLocation({
    lat: fallBackCordinates.latitude,
    lon: fallBackCordinates.longitude,
    method: "Rebuy Geolocation",
    data: data.address,
  });
};

const useWhoIsLocation = async () => {
  console.log("Unable to retrieve your location via Geolocation API");

  const response = await fetch("https://ipwho.is/");
  if (!response.ok) {
    throw new Error("Failed to fetch location from IP");
  }
  const data = await response.json();
  const locatedData = await reverseGeocode(data.latitude, data.longitude);
  
  return setUserLocation({
    lat: data.latitude,
    lon: data.longitude,
    method: "WhoIs",
    data: locatedData.address,
  });
}

// native Geolocation API
const geoLocateUser = async () => {
  if (!navigator.geolocation) {
    return await locateWithAlternativeProvider();
  } else {
    return await navigator.geolocation.getCurrentPosition(onGeoSuccess, locateWithAlternativeProvider);
  }
}

// Reverse geocoding using OpenStreetMap's Nominatim API
const reverseGeocode = async (lat, lng) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch address from coordinates");
  }
  const data = await response.json();
  return data;
};